module.exports = __webpack_public_path__ + "img/background_altromercato_concorso_24.cff33b06.png";